// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","card":"machineryCard_card__hr_Xk"};